import { createSlice } from "@reduxjs/toolkit";

export const shopSlice = createSlice({
  name: "shop",
  initialState: {
    selectedShop: "",
    shopStores: [],
  },
  reducers: {
    setShopStores: (state, action) => {
      state.shopStores = action.payload;
    },
    setShop: (state, action) => {
      state.selectedShop = action.payload;
    },
    resetShop: (state) => {
      state.selectedShop = "";
      state.shopStores = [];
    },
  },
});

const { reducer, actions } = shopSlice;
export const { setShop, resetShop, setShopStores } = actions;
export default reducer;
